import { useEffect, useState } from "react";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";

import useAuth from "./useAuth";
import { child, get, push, ref, set } from "firebase/database";
import { realTimeDB } from "../firebase.config";
import { messaging } from "../firebase.config";
import { getMessaging, getToken } from "firebase/messaging";
export const useLogin = () => {
  let [isCancelled, setIsCancelled] = useState(false);
  let [isLoading, setIsLoading] = useState(false);
  let [error, setError] = useState(null);
  const { dispatch } = useAuth();

  const Login = (email, password, location, navigate, user, giftCardId) => {
    setError(null);
    setIsLoading(true);

    const auth = getAuth();

    const getFcmToken = async () => {
      try {
        // Request notification permission
        const permission = await Notification.requestPermission();
        // console.log(permission);
        if (permission === "granted") {
          // Get FCM token
          const currentToken = await getToken(messaging, {
            vapidKey:
              "BC0uZnskq7BUHu-6gdBaMc-7snsTRII3ZR-VxTZI8LxUAwwn7NsBZLIJhuZivPvwY-ZL-bibxc_YfS7nJvm8HJA", // Replace with your VAPID key
          });
          // console.log(currentToken);
          if (currentToken) {
            // console.log("Current FCM token:", currentToken);
            return currentToken;
            // Send token to your backend server if needed
          } else {
            console.log("No registration token available.");
          }
        }
      } catch (error) {
        console.error("An error occurred while retrieving token:", error);
      }
    };

    signInWithEmailAndPassword(auth, email, password)
      .then(async (res) => {
        dispatch({ type: "LOGIN", payload: res.user });
        if (!isCancelled) {
          setIsLoading(false);
          setError(null);
        }
        let destination;
        // console.log(user);
        if (user === "admin") {
          const tokenRef = ref(realTimeDB, `/admin-token`);
          const token = await getFcmToken();
          // console.log(token);
          if (token) {
            const newDataRef = push(tokenRef);
            get(tokenRef)
              .then((snapshot) => {
                if (snapshot.exists()) {
                  const values = snapshot.val();
                  // console.log(values)
                  const array = Object.values(values);
                  // console.log(array)
                  if (array.includes(token) === false) {
                    set(newDataRef, token);
                  }
                } else {
                  // console.log("No tokens stored yet");
                  set(newDataRef, token);
                }
              })
              .catch((err) => console.log(err));
          }
          destination = "/admin-signin";
        }
        if (user === "psychologist") {
          destination = "/psychologist-signin";
        }

        if (user === "patient" && !giftCardId) {
          destination = "/signin";
        }
        if (user === "patient" && giftCardId) {
          destination = `/gift-card/${giftCardId}`;
        }

        navigate(destination);
      })
      .catch((error) => {
        let errMessage = error?.code?.split("auth/")[1];
        if (errMessage == "wrong-password") {
          setError("Invalid Password");
        } else {
          setError(errMessage);
        }
        setIsLoading(false);
      });

    setError(null);
  };

  useEffect(() => {
    return () => setIsCancelled(true);
  }, []);

  return { setError, error, Login, isLoading };
};
